// frontend/src/components/RecursoItem.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import ListarOrdenesCompraModal from './ListarOrdenesCompraModal';
import './RecursoItem.css';

const RecursoItem = ({
  recurso,
  onUpdate,
  isAprobado = false,
  presupuestoId,
  presupuestoStatus,
  onAbrirOrdenCompra,
  partida,
  area,
  modoSeleccion = false,
  isSelected = false,
  onToggleSeleccion
}) => {
  const [showListarOCModal, setShowListarOCModal] = useState(false);
  const [ocCount, setOcCount] = useState(0);

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const response = await presupuestosService.getOrdenesCompraPorRecurso(recurso.id);
        let ocData = [];

        if (response.data && response.data.results && Array.isArray(response.data.results)) {
          ocData = response.data.results;
        } else if (Array.isArray(response.data)) {
          ocData = response.data;
        }

        setOcCount(ocData.length);
      } catch (error) {
        console.error('Error al cargar OC count:', error);
        setOcCount(0);
      }
    };

    cargarDatos();
  }, [recurso.id]);

  const cargarOcCount = async () => {
    try {
      const response = await presupuestosService.getOrdenesCompraPorRecurso(recurso.id);
      let ocData = [];

      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        ocData = response.data.results;
      } else if (Array.isArray(response.data)) {
        ocData = response.data;
      }

      setOcCount(ocData.length);
    } catch (error) {
      console.error('Error al cargar OC count:', error);
      setOcCount(0);
    }
  };

  const handleDeleteRecurso = async () => {
    if (window.confirm(`¿Eliminar recurso "${recurso.nombre_recurso}"?`)) {
      try {
        await presupuestosService.deleteRecurso(recurso.id);
        toast.success('Recurso eliminado exitosamente');
        onUpdate();
      } catch (error) {
        console.error('Error al eliminar recurso:', error);
        toast.error('Error al eliminar recurso');
      }
    }
  };

  const handleOCStatusChange = () => {
    // Recargar el conteo de OCs cuando se cambia el estado
    cargarOcCount();
  };

  return (
    <>
      <div className={`recurso-item ${isSelected ? 'recurso-selected' : ''}`}>
        <div className="recurso-header">
          {modoSeleccion && (
            <div className="recurso-checkbox">
              <input
                type="checkbox"
                checked={isSelected}
                onChange={onToggleSeleccion}
                className="checkbox-seleccion"
              />
            </div>
          )}

          <div className="recurso-icon">🔧</div>

          <div className="recurso-info">
            <h5>{recurso.nombre_recurso}</h5>
            <div className="recurso-details">
              <span className="detail">{recurso.cantidad} {recurso.unidad}</span>
              <span className="detail">× ${recurso.valor_unitario.toLocaleString('es-CL')}</span>
              {recurso.proveedor_nombre && (
                <span className="detail proveedor">Proveedor: {recurso.proveedor_nombre}</span>
              )}
            </div>
          </div>

          <div className="recurso-total">
            ${recurso.total_recurso.toLocaleString('es-CL')}
          </div>

          <div className="recurso-actions">
            {presupuestoStatus === 'aprobado' && (
              <>
                {ocCount > 0 && (
                  <button
                    className="btn btn-listar-oc"
                    onClick={() => setShowListarOCModal(true)}
                    title={`Ver ${ocCount} orden(es) de compra`}
                  >
                    📋 {ocCount}
                  </button>
                )}
                <button
                  className="btn btn-oc"
                  onClick={() => onAbrirOrdenCompra(recurso, partida, area)}
                  title="Crear orden de compra"
                >
                  ➕ OC
                </button>
              </>
            )}
          </div>

          {!isAprobado && (
            <button
              className="btn btn-delete"
              onClick={handleDeleteRecurso}
              title="Eliminar recurso"
            >
              🗑️
            </button>
          )}
        </div>

        {recurso.descripcion && (
          <div className="recurso-description">
            {recurso.descripcion}
          </div>
        )}
      </div>

      {showListarOCModal && (
        <ListarOrdenesCompraModal
          recursoId={recurso.id}
          recursoNombre={recurso.nombre_recurso}
          onClose={() => setShowListarOCModal(false)}
          onStatusChange={handleOCStatusChange}
        />
      )}
    </>
  );
};

export default RecursoItem;
